// Client attribution headers (ANALYTICS ONLY).
//
// The backend reads `X-Client-Platform` to stamp `signup_platform` at
// registration and `has_app`/`platforms_seen` on authenticated requests. This
// is the web bundle, so the platform is always 'web'. No auth or payment
// decision depends on this header — it is purely for analytics attribution.
//
// Spread `...clientHeaders()` into the `headers` of every auth/identity fetch.

export const CLIENT_PLATFORM = 'web';
export const CLIENT_VERSION = process.env.REACT_APP_VERSION || 'web-1.0.0';

export const clientHeaders = () => ({
  'X-Client-Platform': CLIENT_PLATFORM,
  'X-Client-Version': CLIENT_VERSION,
});

// Identity header (NOT analytics) — kept separate from clientHeaders() so the
// analytics-only contract above stays clean. When the visitor created a
// guest doc during onboarding, forward its id on OTP-login calls so the
// backend (extract_guest_user_id → find_or_convert_guest_or_upsert Path 2)
// converts that doc in place instead of orphaning it behind a new account.
// Only guest_-prefixed ids are honoured server-side; absence → {} (no-op).
export const guestHeaders = () => {
  try {
    const id = localStorage.getItem('guest_user_id');
    if (id && id.startsWith('guest_')) return { 'X-Guest-User-Id': id };
  } catch { /* localStorage unavailable — skip */ }
  return {};
};

export default clientHeaders;
